import { Component, OnInit  } from '@angular/core';
import { NavController  } from 'ionic-angular';
import { WebService } from '../../app/shared/web.service';
import { AuthService } from '../../app/shared/auth.service';
import { LeagueService } from '../../app/shared/league.service';

import * as env from '../../app/shared/env';

@Component({
  selector: 'page-leagues',
  templateUrl: 'leagues.html'
})
export class LeaguesPage implements OnInit {

  leagues;

  constructor(public navCtrl: NavController, private web: WebService, public auth: AuthService, private leagueService:LeagueService) {
    this.leagues = [];
  }

  ngOnInit(): void {

    this.web.get(env.appBaseUrl + '/league').subscribe(data => {
		  this.leagueService.setGroupinfo(data);
		  this.leagues = [];
		  let leagueid = 0;
		  let league;
		  data.forEach(value => {
		    if (leagueid != value.leagueid) {
			    leagueid = value.leagueid
			    league = {};
			    league.id = leagueid;
			    league.desc = value.leaguedesc;
			    league.league = value.league;
          league.season = value.season;
          league.img = "assets/media/" + league.league + "." + league.season + ".h144.jpg"; 
			    league.groups = [];
			    this.leagues.push(league);
		    };
		    let group = {};
		    group['id'] = value.groupid;
		    group['name'] = value.groupname;
		    group['notInGroup'] = (value.userid == null);
		    group['started'] = (value.startdate <= (new Date()).getTime());
		    group['archived'] = (value.enddate <= (new Date()).getTime());
		    league.groups.push(group);
		  });
    });
  }

  // goToGroupPage(id) {
  //   this.navCtrl.push('GroupstandingsPage', {groupid:id, limit:0})
  //             .then((permission) => {
  //                 console.log(permission);
  //                 if (!permission) {
  //                     this.navCtrl.setRoot('LoginPage');
  //                 }
  //             });
  // }
            


  goToGroupSummary(id) {
    this.leagueService.setDefaultGroup(id);
    this.navCtrl.setRoot('GroupsummaryPage', {groupid:id});
  }

  goToGroupRules(id) {
    this.navCtrl.push('RulesPage', {groupid:id});
    console.log(this.navCtrl);
  }
  
  ionViewCanEnter(): boolean {
    //return this.auth.isAuth();
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/pages/leagues/leagues.ts